var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.641 6.25453H8.4359V1.0494C8.4359 0.851968 8.27436 0.69043 8.07692 0.69043H5.92308C5.72564 0.69043 5.5641 0.851968 5.5641 1.0494V6.25453H0.358974C0.161538 6.25453 0 6.41607 0 6.61351V8.76735C0 8.96479 0.161538 9.12633 0.358974 9.12633H5.5641V14.3315C5.5641 14.5289 5.72564 14.6904 5.92308 14.6904H8.07692C8.27436 14.6904 8.4359 14.5289 8.4359 14.3315V9.12633H13.641C13.8385 9.12633 14 8.96479 14 8.76735V6.61351C14 6.41607 13.8385 6.25453 13.641 6.25453Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddWhite);
export default __webpack_public_path__ + "static/media/addWhite.cc8ad8aa18666f8c890c811c4a8d2082.svg";
export { ForwardRef as ReactComponent };